import React, { useCallback, useEffect, useLayoutEffect, useMemo, useState, } from 'react';
import { AppView } from 'design-system';
import Button from 'design-system/Button';
import StatusBar from 'design-system/StatusBar';
import ClaimRewardsList from 'features/rewards/components/ClaimRewardsList';
import ClaimRewardsTopContainer from 'features/rewards/components/ClaimRewardsTopContainer';
import { useRedemptions } from 'hooks';
import useColors from 'hooks/useColors';
const ClaimRewards = ({ navigation }) => {
    const colors = useColors();
    const { redemptions, isRedemptionsFetching, fetchRedemptions } = useRedemptions();
    useLayoutEffect(() => {
        navigation.setOptions({
            title: 'Cashback',
            headerTintColor: colors.text.primary,
        });
    }, [colors.text.primary]);
    useEffect(() => {
        fetchRedemptions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const onPressClaim = useCallback(() => {
        navigation.navigateDeprecated('ClaimRewardsDetails');
    }, []);
    const renderButton = useMemo(() => {
        if (!(redemptions && redemptions.available))
            return null;
        const { available } = redemptions;
        const { balance } = available;
        if (selectedIndex && balance >= 5) {
            return (<Button brand floating onPress={onPressClaim} title="Claim your money back!"/>);
        }
        return null;
    }, [onPressClaim, redemptions, selectedIndex]);
    return (<AppView avoidHeader withFrame={false}>
      <StatusBar barStyle="dark-content"/>
      <ClaimRewardsTopContainer selectedIndex={selectedIndex} redemptions={redemptions}/>
      <ClaimRewardsList isFetching={isRedemptionsFetching} redemptions={redemptions} onChangeTab={setSelectedIndex} selectedIndex={selectedIndex}/>
      {renderButton}
    </AppView>);
};
export default ClaimRewards;
